import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";

interface JobAidProps {
  jobAidUrl: string;
  showModal: boolean;
  handleModal: () => void;
}

const JobAidModal: React.FC<JobAidProps> = ({
  jobAidUrl,
  showModal,
  handleModal,
}) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
  }, [jobAidUrl]);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement | HTMLIFrameElement, Event>) => {
    console.error("Image failed to load", e);
    setLoading(false);
  };

  return (
    <Modal
      show={showModal}
      onHide={handleModal}
      centered
      fullscreen="xxl-down"
      size="xl"
      width="fit-content"
      keyboard={true}
      contentClassName="h-100"
      dialogClassName="h-75"
    >
      <Modal.Header closeButton>
        <Modal.Title>Job Aid</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center overflow-auto">
        {loading && (
          <div className="align-self-center position-absolute">
            <Spinner />
          </div>
        )}
        {jobAidUrl.includes(".pdf") ? (
            <iframe
              content="job-aid"
              className="align-self-center h-100 w-100"
              aria-controls=""
              src={jobAidUrl}
              title="Job Aid"
              loading="lazy"
              onLoad={() => setLoading(false)}
              onError={handleError}

            />
        ) : (
            <div className="d-flex justify-content-center align-items-center">
              <img
                className="align-self-center h-100 w-100"
                src={jobAidUrl}
                alt="Job Aid"
                title="Job Aid"
                loading="lazy"
                onLoad={() => setLoading(false)}
                onError={handleError}
              />
            </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default JobAidModal;
